<template>
	<div class="info-page">
		<b-container>
			<b-row>
				<b-col md="8">
					<h1>FAQs</h1>
					<div class="faq">
						<div class="faq--questions">
							<Question title="Ist skilldoo wirklich kostenlos?">
								<p>Ja, skilldoo ist für BewerberInnen gratis. Die anfallenden Kosten tragen
									ausschließlich die ArbeitgeberInnen.</p>
							</Question>
							<Question title="Ist skilldoo komplett anonym?">
								<p>Bei skilldoo kannst du selbst auswählen, wie lange du anonym bleiben willst. So
									kannst du problemlos nach einem Job suchen, während du noch angestellt bist. Dadurch
									zählt nur, was du kannst. Und nicht dein Geschlecht, deine Nationalität oder dein
									Alter. Aber selbstverständlich wird dein künftiger Arbeitgeber dich irgendwann näher
									kennenlernen wollen. Sobald das der Fall ist, liegt es an dir, ob du deinen
									Anonymität aufhebst. Es gibt dabei keinen Zwang.</p>
							</Question>
							<Question title="Benötige ich bei skilldoo wirklich keinen Lebenslauf?">
								<p>Mit skilldoo benötigst du grundsätzlich keinen Lebenslauf, denn das Best-Match-System
									funktioniert trotzdem.
									<br/>Selbstverständlich kann es sein, dass dein künftiger Arbeitgeber irgendwann von
									dir einen Lebenslauf verlangt. Darauf hat skilldoo keinen Einfluss.</p>
								<p>Daher steht es dir frei, einen Lebenslauf in skilldoo hochzuladen.</p>
								<p>Oder noch besser und einfacher: du nutzt unsere Lebenslauf-Vorlage, die von
									Personalvermittler-Experten entwickelt wurde und dich und deine Skills optimal
									darstellt. Sie ist schnell und intuitiv auszufüllen, es ist keine Formatierung
									notwendig, du musst nur die Textfelder ausfüllen.</p>
							</Question>
							<Question title="Wie findet skilldoo den passenden Job für mich?">
								<p>Du gibst skilldoo durch einfaches Anklicken deiner Erfahrungen und Fähigkeiten in
									wenigen Schritten bekannt, was du kannst und was du willst. Der Arbeitgeber gibt
									bekannt, welche Position er besetzen will und welche Erfahrungen und Fähigkeiten er
									sich erwartet. skilldoo sucht am Schluss automatisch nach dem Best-Match. Sprich,
									welche BewerberInnen am besten zu ausgeschriebenen Stellen passen. Dabei muss es
									keine 100%ige Übereinstimmung geben. Denn im Leben läuft auch nicht alles
									perfekt.</p>
							</Question>
							<Question title="Was ist ein Best-Match?">
								<p>skilldoo sucht für dich nach dem Best-Match. Das bedeutet, dass nach der
									bestmöglichen Übereinstimmung zwischen den Anforderungen des Arbeitgebers und deinem
									Profil gesucht wird. Sobald eine hohe und signifikante Übereinstimmung besteht,
									bringt skilldoo dich und den potenziellen Arbeitgeber in Verbindung. Dann könnt ihr
									direkt in Kontakt treten. Selbstverständlich bleibst du dabei so lange anonym, wie
									du es für richtig hältst. Unser Best-Match-System dient also dazu, dass du keine
									Zeit verlierst und gleichzeitig die wirklich passenden Jobangebote erhältst. Denn
									bei althergebrachten Plattformen musst du dich immer wieder aufs Neue bewerben. Und
									du weißt nicht, ob überhaupt Interesse an dir und deinen Qualifikationen
									besteht.</p>
							</Question>
							<Question title="Wer steckt hinter skilldoo?">
								<p>skilldoo wurde von einem erfahrenen Team unter Leitung von Peter Fiala und Alexander
									Schlögl entwickelt.</p>
								<p>Peter ist seit mehr als zwei Jahrzehnten als Unternehmer auf hochwertige
									Stellenvermittlung bzw. Recruiting spezialisiert. Alex ist ein seit 20 Jahren
									gefragter Softwareentwickler und verantwortet die digitale Umsetzung in allen
									Bereichen. Das Unternehmen ist in Österreich beheimatet.</p>
								<p>Wir haben die Wünsche von BewerberInnen und ArbeitgeberInnen sowie jahrzehntelange
									Erfahrung einfließen lassen, um mit geringem Zeitaufwand zum bestmöglichen Job zu
									gelangen. Skills und Wünsche werden bestmöglich berücksichtigt.</p>
							</Question>
							<Question title="Muss ich mich wirklich nur 1 Mal bewerben?">
								<p>Ja, das ist einer der wesentlichsten Vorteile von skilldoo als moderner
									Jobmatching-Plattform im Vergleich zu althergebrachten Jobbörsen. Du gibst nur 1 Mal
									deine Daten ein und skilldoo sucht automatisch für dich nach den passenden Jobs. So
									musst du nicht täglich nach Jobs suchen und dich zeitaufwändig bei unzähligen
									Arbeitgebern bewerben.</p>
							</Question>
							<Question title="Sind die Jobs bei skilldoo immer aktuell?">
								<p>Ja, das ist einer der großen Vorteile im Vergleich zu den klassischen Jobbörsen.
									Sobald ein Job vergeben ist, wird er aus dem System gestrichen. Es ist für dich als
									BewerberIn aber auch nicht so wichtig, denn skilldoo sucht sowieso automatisiert nur
									nach dem passenden Job für dich. Somit verlierst du auf jeden Fall keine wertvolle
									Zeit.</p>
							</Question>
							<Question
								title="Welche Vorteile bietet die Job-Matching Plattform skilldoo gegenüber althergebrachten Job-Plattformen?">
								<p>skilldoo bietet dir im Vergleich einige Vorteile. Du sparst wertvolle Zeit, weil du
									dich nur 1 Mal bewerben musst. Denn sobald du deine Daten eingetragen hast, sucht
									skilldoo automatisch nach dem am besten passenden Job für dich. Das erledigt das
									Best-Match-System, das speziell für skilldoo entwickelt wurde. Das funktioniert
									ungefähr so wie bei bekannten Dating-Plattformen. Die Anonymität ist ebenso ein
									großer Vorteil. Denn dadurch zählen nicht dein Geschlecht, dein Alter oder deine
									Nationalität für die Auswahl. Im Vordergrund stehen deine Wünsche, Qualifikationen
									und Bedürfnisse. Du musst auch keinen Lebenslauf hochladen. Aber selbstverständlich
									kannst du das jederzeit tun, wenn du es willst, oder du nutzt unsere
									Lebenslauf-Vorlage, die einfach und schnell auszufüllen ist. Die eingebaute
									Kontakt-Funktion ermöglicht es dir, direkt mit den ArbeitgeberInnen in Kontakt zu
									treten. Du schickst also nicht unbemerkt und umsonst viele E-Mails aus, um meist
									keine Antwort zu bekommen. Und zum Schluss noch ein Vorteil: trotz des tollen
									Angebots ist skilldoo für BewerberInnen kostenlos!</p>
							</Question>
						</div>
					</div>
				</b-col>
				<b-col md="4" class="mt-4 mt-md-0">
					<div class="avatar-text-button text-center">
						<Avatar :avatar="avatar"/>
						<div class="title">Noch keinen Account?</div>
						<Button text="Los geht's" href="/kandidat" icon="caret-right"/>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Question from "./faq/Question";
import Jon from "@/vue/common/image/Jon.vue";
import Avatar, {IDEA_LIGHT_BULB} from "@/vue/common/image/Avatar.vue";
import Button from "@/vue/common/Button.vue";

export default {

	components: {
		Button,
		Avatar,
		Jon,
		Question,
	},

	computed: {
		avatar ()
		{
			return IDEA_LIGHT_BULB;
		}
	}
}
</script>
